// import statuses from '@/store/statuses';
import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {
    user: null,
    token: null,
    exp: 0, // Token expiration time in seconds (UTC) from token
    refreshToken: null,
    refreshTokenExp: 0,
    roles: [],
    permissions: [],
    routeMeta: {}, // Not sure what this is for
    hasAuthInfo: false,
    abilities: [],
  };
};

const store = {
  namespaced: true,
  state: defaultState,
  getters: {
    user: (state) => state.user,

    token: (state) => state.token,
    refreshToken: (state) => state.refreshToken,

    tokenValid: (state) => (offsetSecs = 0) => state.token && (state.exp - offsetSecs > new Date().getTime() / 1000),
    refreshTokenValid: (state) => (offsetSecs = 0) => state.refreshToken && (state.refreshTokenExp - offsetSecs > new Date().getTime() / 1000),

    roles: (state) => state.roles,
    permissions: (state) => state.permissions,

    isLoggedIn: (state) => state.hasAuthInfo && (state.exp > new Date().getTime() / 1000 || (state.refreshToken && state.refreshTokenExp.exp > new Date().getTime() / 1000)),
  },
  mutations,
  actions,
};

export { store, defaultState };
